import { ModuleFE_Account } from './ModuleFE_Account.js';
import { ModuleFE_Session } from '../session/ModuleFE_Session.js';
export const ModulePackFE_AccountDB = [ModuleFE_Account, ModuleFE_Session];
//# sourceMappingURL=module-pack.js.map